import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import Section10CImg from "../../img/CWTA.webp";
import { TbCircleNumber2Filled } from "react-icons/tb";

const Section10C = ({ ComponentData, index }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          // width: { xl: "72%", lg: "80%", md: "95%", sm: "94%" },
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          justifyContent: { xl: "space-between", lg: "space-between" },
          // border: "1px solid blue",
          // px: { xs: 2, md: 5 },
          py: 4,
        }}
      >
        {/* mobile Text Content */}
        <Box
          sx={{
            maxWidth: { xs: "100%", md: "600px" },
            marginBottom: { xs: "24px", md: "0" },
            display: { xs: "flex", sm: "none" },
            flexDirection: "column",
          }}
        >
          {/* <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: "16px",
              lineHeight: {
                lg: "48px",
                xl: "48px",
                md: "32px",
                xs: "24px",
                sm: "24px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "40px",
                xl: "40px",
                md: "28px",
                xs: "20px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 600,
                xl: 600,
                xs: 600,
                sm: 600,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
            }}
          >
           
            {ComponentData[index]?.section10B?.card_head1}
          </Typography> */}

          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
              // border: "1px solid red",
              // alignItems: "center",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                height: "60px",
                width: "60px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TbCircleNumber2Filled size={40} />
            </Stack>

            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginBottom: "16px",
                lineHeight: {
                  lg: "32px",
                  xl: "32px",
                  md: "32px",
                  xs: "24px",
                  sm: "24px",
                },
                // fontSize: "18px",
                fontSize: {
                  lg: "28px",
                  xl: "28px",
                  md: "28px",
                  xs: "20px",
                  sm: "20px",
                },
                fontFamily: "'Roboto', sans-serif",
                fontWeight: {
                  lg: 600,
                  xl: 600,
                  xs: 600,
                  sm: 600,
                },
                color: "rgb(0, 0, 0)",
                // paddingLeft: "12px",
                padding: "12px",
                // paddingRight: "12px",
                // border: "1px solid rgb(218 233 248)",
                borderRadius: "8px",
                display: {
                  xl: "flex",
                  lg: "flex",
                  md: "flex",
                  sm: "flex",
                  xs: "flex",
                },
              }}
            >
              {ComponentData[index]?.section10B?.card_head1}
            </Typography>
          </Stack>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* Capture Leads & collect useful information Directly in WhatsApp
            Chats with WhatsApp Forms. */}
            {ComponentData[index]?.section10B?.card_head2}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "32px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* From feedback to gathering user insights, collect it all on
            WhatsApp. */}
            {ComponentData[index]?.section10B?.card_head3}
          </Typography>
        </Box>
        {/* Image Section */}
        <Box
          component="img"
          // src={Section10CImg}
          src={ComponentData[index]?.section10B?.card_image}
          alt="Section 10B"
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
          }}
        />

        {/* desktop Text Content */}
        <Box
          sx={{
            maxWidth: { xs: "100%", md: "600px" },
            marginBottom: { xs: "24px", md: "0" },
            display: { xs: "none", sm: "flex" },
            // border: "1px solid red",
            flexDirection: "column",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
              // border: "1px solid red",
              // alignItems: "center",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                height: "60px",
                width: "60px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TbCircleNumber2Filled size={40} />
            </Stack>

            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginBottom: "16px",
                lineHeight: {
                  lg: "32px",
                  xl: "32px",
                  md: "32px",
                  xs: "24px",
                  sm: "24px",
                },
                // fontSize: "18px",
                fontSize: {
                  lg: "28px",
                  xl: "28px",
                  md: "28px",
                  xs: "20px",
                  sm: "20px",
                },
                fontFamily: "'Roboto', sans-serif",
                fontWeight: {
                  lg: 600,
                  xl: 600,
                  xs: 600,
                  sm: 600,
                },
                color: "rgb(0, 0, 0)",
                // paddingLeft: "12px",
                padding: "12px",
                // paddingRight: "12px",
                // border: "1px solid rgb(218 233 248)",
                borderRadius: "8px",
                display: {
                  xl: "flex",
                  lg: "flex",
                  md: "flex",
                  sm: "flex",
                  xs: "flex",
                },
              }}
            >
              {ComponentData[index]?.section10B?.card_head1}
            </Typography>
          </Stack>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* Capture Leads & collect useful information Directly in WhatsApp
            Chats with WhatsApp Forms. */}
            {ComponentData[index]?.section10B?.card_head2}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "32px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* From feedback to gathering user insights, collect it all on
            WhatsApp. */}
            {ComponentData[index]?.section10B?.card_head3}
          </Typography>
          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "rgb(5, 78, 146)",
              borderColor: "rgb(5, 78, 146)",
              color: "white",
              padding: "10px 20px",
              textTransform: "none",
              width: "20%",
              marginLeft: { xs: "16px", sm: "none" },
              "&:hover": {
                backgroundColor: "rgb(31, 133, 192)", // Hover background
                borderColor: "rgb(31, 133, 192)", // Hover border
              },
            }}
          >
            Explore →
          </Button> */}
        </Box>
      </Box>
    </Stack>
  );
};

export default Section10C;
